import { AuthenticationErrorCode } from '@/types/api/payment-user';
// @ts-ignore
import MembersIcon from '@/images/members-icon.svg?react';
import CopyInviteLinkButton from '../../membership/copy-invite-link-button';
import ShareInviteLinkButton from '../../membership/share-invite-link-button';
import CreateContactInvitationsInput from '../../membership/create-contact-invitations-input';
import { MembershipRole } from '@/types/api/membership';
import MembershipRoleSelect from '../../membership/membership-role-select';
import * as React from 'react';
import { useLinkInvitationQuery } from '@/hooks/membership/queries/use-link-invitation.query';
import { CircleX, LoaderCircle } from 'lucide-react';
import { cn } from '@/utils/shared/Utils';

export interface AddMembersModalProps {
  errorCode: AuthenticationErrorCode;
}

export default function AddMembersModal({}: AddMembersModalProps) {
  const [role, setRole] = React.useState<MembershipRole>(MembershipRole.Member);
  const { data, isPending, isError } = useLinkInvitationQuery(role);

  return (
    <div className="flex flex-col gap-4">
      {/* Content */}
      <div className="w-full">
        {/* Modal header */}
        <div className="mb-5 flex items-center gap-2">
          <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-gray-100 dark:bg-gray-700">
            <MembersIcon className="shrink-0 fill-current text-blue-500" />
          </div>
          <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">Lägg till gruppmedlemmar</div>
        </div>

        {/* Modal content */}
        {!data && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            {isPending && <LoaderCircle size={40} className="animate-spin" />}
            {isError && (
              <div className="flex flex-col items-center gap-4">
                <CircleX size={40} color="red" />
                Ett fel uppstod, försök igen senare.
              </div>
            )}
          </div>
        )}

        <div className={cn('text-sm space-y-3', !data && 'filter blur-sm pointer-events-none')}>
          <div className="flex">
            <MembershipRoleSelect value={role} onChange={setRole} />
          </div>

          <CreateContactInvitationsInput role={role} />

          <div className="flex items-center w-full">
            <hr className="flex-grow h-px bg-gray-200 dark:bg-gray-700/60 border-none" />
            <span className="mx-4 text-gray-500 dark:text-gray-400">eller</span>
            <hr className="flex-grow h-px bg-gray-200 dark:bg-gray-700/60 border-none" />
          </div>

          <ShareInviteLinkButton token={data?.token!} />

          <CopyInviteLinkButton token={data?.token!} />
        </div>
      </div>
    </div>
  );
}
